<template>
    <kgr-form-scaffold 
        :pending="pending"
        :with-primary-buttons="false"
        @backBtnClicked="onBack"
    >
        <kgr-member-article-sales-evaluation-form
            :member-id="memberId"
            :club-id="clubId"
            :error="error"
        />
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import MemberArticleSalesEvaluationForm from '../../components/members/article-sales/MemberArticleSalesEvaluationForm';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-member-article-sales-evaluation-form': MemberArticleSalesEvaluationForm,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            pending: false,
            error: new Error()
        };
    },
    methods: {
        onBack() {
            window.location = this.overviewUrl;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
